// // Use the ui-select-open-on-focus directive on the ui-select element
angular.module('tgaAdmin').directive('uiSelectFocusOnOpen', () => ({
  restrict: 'A',
  require: 'uiSelect',
  link(scope, elt, attrs, $select) {
    scope.$watch('$select.open', () => {
      if ($select.open === true) {
        $select.searchInput[0].focus();
      }
    });
  },
}));
